import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../utils/appUtils";
import TableDT from "../../UI/TableDT";
import { TabView, TabPanel } from 'primereact/tabview';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GetInfoMC } from "../../../api";
import { Button } from 'primereact/button';
import { useAsyncEffect } from "../../UI/useAsyncEffect";

const ROUTE_URL = "/get_conn_mc";

function MsDataMod(props) {
    const token = localStorage.getItem('token')
    clearInterval(window.timer)
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const [currentPageOne, setCurrentPageOne] = useState(1);
    const [activeIndex, setActiveIndex] = useState(0)
    const [arrTableOne, setArrTableOne] = useState([])
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState();
    const navigate = useNavigate();

    const handleAddRow = () => {
        navigate("./create");
    };

    useAsyncEffect(async () => {
        let offset = (currentPageOne - 1) * 10;
        await GetInfoMC(token, ROUTE_URL, activeIndex + 1, offset, 10).then((e) => {
            e.data.data.forEach((el, i) => {
                el.timestamp = new Date(e.data.timestamp[i]).toLocaleString("ru")
            })
            setArrTableOne(e.data.data)
        })
        if (!date) {
            setDate(Date.now())
        }
    }, [currentPageOne, activeIndex])


    const handleClick = (event) => {
        if (loading) return;
       event && event.preventDefault();
       event && event.target.blur();
        //    refreshData();
        let offset = (currentPageOne - 1) * 10;
        GetInfoMC(token, ROUTE_URL, activeIndex + 1, offset, 10).then((e) => {
            e.data.data.forEach((el, i) => {
                el.timestamp = new Date(e.data.timestamp[i]).toLocaleString("ru")
            })
            setArrTableOne(e.data.data)
        })
        setLoading(true);
        setDate(Date.now())
        setTimeout(() => {
          setLoading(false);
        }, 650);
    }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
    }, []);




    if (serverData === null)
        return <MainArea loading />;

    return (
        <MainArea>
            <MainAreaHeader caption="МС (поправки)" />
            <MainAreaBody containerClass="">
                {/* {
                    <div><button type="button" className="btn btn-primary btn-sm btn-our" onClick={handleAddRow}>Добавить</button></div>
                } */}
                {/* <TableDT getOptions={() => dtTable.getTableOptions(serverData.crud)} afterCreate={handleAfterDTCreate} /> */}

                <div className="container-fluid px-3 py-1 dashboard">
                    <div className="row g-3">
                    <TabView activeIndex={activeIndex} onTabChange={(e) => {setActiveIndex(e.index)
                        setCurrentPageOne(1)
                    }}> 
                        <TabPanel header="Комплект 1">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="timestamp" sortable header="Дата и время"></Column>
                                <Column field="ps_number" sortable header="Номер МС в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес в служебном канале"></Column>
                                <Column field="a0" sortable header="Текущая поправка по дальности"></Column>
                                <Column field="a1" sortable header="Текущая поправка по скорости"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Комплект 2">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="timestamp" sortable header="Дата и время"></Column>
                                <Column field="ps_number" sortable header="Номер МС в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес в служебном канале"></Column>
                                <Column field="a0" sortable header="Текущая поправка по дальности"></Column>
                                <Column field="a1" sortable header="Текущая поправка по скорости"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Комплект 3">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="timestamp" sortable header="Дата и время"></Column>
                                <Column field="ps_number" sortable header="Номер МС в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес в служебном канале"></Column>
                                <Column field="a0" sortable header="Текущая поправка по дальности"></Column>
                                <Column field="a1" sortable header="Текущая поправка по скорости"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Комплект 4">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="timestamp" sortable header="Дата и время"></Column>
                                <Column field="ps_number" sortable header="Номер МС в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес в служебном канале"></Column>
                                <Column field="a0" sortable header="Текущая поправка по дальности"></Column>
                                <Column field="a1" sortable header="Текущая поправка по скорости"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                    </TabView>
                            <div className="lower-line">
                                <div className="text-cont">
                                    <div className="text">Состояние актуально на:</div>
                                    <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
                                </div>
                                <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
                          </div>
                        </div>
                </div>

            </MainAreaBody>
        </MainArea>
    );
}


export default MsDataMod;
